import React, { useMemo } from 'react';
import { parseMentions } from '../utils/mentionUtils';
import { Text } from '@mantine/core';
import { createDeletedUser } from '@tickitacka/shared';
import { useTranslation } from 'react-i18next';

interface CommentContentProps {
    content: string;
    mentionedUsers: Record<
        string,
        { id: string; name: string; profile_image_url: string }
    >;
}

// 메모이제이션된 컴포넌트
export const CommentContent = React.memo(
    ({ content, mentionedUsers }: CommentContentProps) => {
        const { t } = useTranslation('common');
        // 파싱된 콘텐츠 메모이제이션
        const parsedContent = useMemo(() => parseMentions(content), [content]);

        return (
            <Text c="black" fz="sm">
                {parsedContent.map((part, index) => {
                    if (part.type === 'text') {
                        // 줄바꿈 처리를 위해 white-space: pre-line 사용
                        return (
                            <Text
                                key={`text-${index}`}
                                span
                                size="sm"
                                style={{
                                    whiteSpace: 'pre-line',
                                    display: 'inline',
                                }}
                            >
                                {part.content}
                            </Text>
                        );
                    } else if (part.type === 'mention' && part.userId) {
                        const userInfo = mentionedUsers[part.userId];

                        // 사용자 정보가 있으면 표시, 없으면 탈퇴한 사용자로 표시
                        const displayName = userInfo
                            ? userInfo.name
                            : createDeletedUser(t).name;

                        return (
                            <Text
                                key={`mention-${index}`}
                                style={{
                                    whiteSpace: 'pre-line',
                                    display: 'inline',
                                }}
                                span
                                fw={700}
                                size="sm"
                                c={userInfo ? '#228BE6' : 'gray'}
                            >
                                @{displayName}
                            </Text>
                        );
                    }

                    return (
                        <Text
                            size="sm"
                            span
                            key={`text-${index}`}
                            style={{
                                whiteSpace: 'pre-line',
                                display: 'inline',
                            }}
                        >
                            {part.content}
                        </Text>
                    );
                })}
            </Text>
        );
    }
);

CommentContent.displayName = 'CommentContent';
